import { render, staticRenderFns } from "./IconWistia.vue?vue&type=template&id=08d41251&"
import script from "./IconWistia.vue?vue&type=script&lang=js&"
export * from "./IconWistia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08d41251')) {
      api.createRecord('08d41251', component.options)
    } else {
      api.reload('08d41251', component.options)
    }
    module.hot.accept("./IconWistia.vue?vue&type=template&id=08d41251&", function () {
      api.rerender('08d41251', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconWistia.vue"
export default component.exports